var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M49 24.6497C49 11.036 38.031 0 24.5 0C10.969 0 0 11.036 0 24.6497C0 36.9529 8.95925 47.1508 20.6719 49V31.775H14.4512V24.6497H20.6719V19.2191C20.6719 13.0412 24.3296 9.6288 29.9259 9.6288C32.6056 9.6288 35.4102 10.1102 35.4102 10.1102V16.1764H32.3209C29.2775 16.1764 28.3281 18.0766 28.3281 20.0279V24.6497H35.123L34.0368 31.775H28.3281V49C40.0408 47.1508 49 36.9529 49 24.6497Z","fill":"black"}));
}

Facebook.defaultProps = {"width":"49","height":"49","viewBox":"0 0 49 49","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
